import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import BasicDetails from "./BasicDetails";
import TermsAgreement from "./TermsAgreement";
import InitialSettlement from "./InitialSettlement";
import { MdClose } from "react-icons/md";
import tw from "tailwind-styled-components";
import { useMutation, useQuery } from "react-query";
import axios from "axios";
import Config from "../../Config";
import AddLocation from "../Location/AddLocation";
import SideModal from "../SideModal";
import { Save_Locations } from "../../Redux/actions";
import { useDispatch } from "react-redux";
import { ModalHeader } from "../Styles/InputStyles";

const AddPropertyPage = ({ setIsAddProperty, user, getListMutate, step, setStep, selectedData }) => {
    const [propId, setPropId] = useState();
    const dispatch = useDispatch();
    const [stepOneData, setStepOneData] = useState(null);
    const [height, setHeight] = useState(window.innerHeight);
    const [showAddLocation, setShowAddLocation] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setHeight(window.innerHeight); // updates when Safari UI changes
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    //------- Basic Detail Property -------
    const AddBasicDeatilFunction = async (values) => {
        return await axios.post(`${Config.apiUrl}/property/add/basic `, values, {
            headers: {
                authorization: "Bearer" + " " + user.token,
                "Content-Type": "application/json",
            },
        });
    };
    const onAddDetailSuccess = (data, variables) => {
        if (data?.data?.isSuccess === true) {
            toast.success(data?.data?.msg || "Success");
            setPropId(data?.data?.propId);
            setStepOneData(variables);
            setStep(step + 1);
        } else {
            toast.error(data?.data?.msg || "An Error Occured");
        }
    };

    const onAddDetailError = (data) => {
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const { isLoading: addBasicDeailLoading, mutate: addBasicDetailMutate } =
        useMutation(AddBasicDeatilFunction, {
            onSuccess: onAddDetailSuccess,
            onError: onAddDetailError,
        });

    //------- Terms & Agreement Property -------
    const AddTermsFunction = async (values) => {
        return await axios.post(`${Config.apiUrl}/property/add/tenant `, values, {
            headers: {
                authorization: "Bearer" + " " + user.token,
                "Content-Type": "application/json",
            },
        });
    };
    const onTermSuccess = (data) => {
        if (data?.data?.isSuccess === true) {
            toast.success(data?.data?.msg || "Success");
            setStep(step + 1);
        }
    };

    const onTremError = (data) => {
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const { isLoading: addTermLoading, mutate: addTermMutate } =
        useMutation(AddTermsFunction, {
            onSuccess: onTermSuccess,
            onError: onTremError,
        });

    //------- Rent Property -------
    const AddRentFunction = async (values) => {
        return await axios.post(`${Config.apiUrl}/property/add/rent `, values, {
            headers: {
                authorization: "Bearer" + " " + user.token,
                "Content-Type": "application/json",
            },
        });
    };
    const onRentSuccess = (data) => {
        if (data?.data?.isSuccess === true) {
            toast.success(data?.data?.msg || "Success");
            setStep(1);
            setIsAddProperty(false);
            getListMutate();
        }
    };

    const onRentError = (data) => {
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const { isLoading: addRentLoading, mutate: addRentMutate } =
        useMutation(AddRentFunction, {
            onSuccess: onRentSuccess,
            onError: onRentError,
        });
    const handleClose = () => {
        setStep(1);
        setIsAddProperty(false);
        getListMutate()
    };

    //------- Add Location Model -------

    const addLocationFunction = async (payload) => {
        return await axios.post(`${Config.apiUrl}/property/add/location`, payload, {
            headers: {
                authorization: `Bearer ${user.token}`,
            },
        });
    };

    const { isLoading: addLocationLoading, mutate: addLocationMutate } = useMutation(
        addLocationFunction,
        {
            onSettled: () => {
                setShowAddLocation(false);
            },
            // onSuccess: ({ data }) => {
            //     toast.success(data?.msg || 'Success');
            // },
            onSuccess: ({ data }) => {
                if (data?.isSuccess === true) {
                    toast.success(data?.msg || 'Location added successfully');

                    if (data?.locations && Array.isArray(data.locations)) {
                        const defaultLocations = {
                            id: 0,
                            name: "All Locations",
                            clientId: user.clientId || 0,
                        };

                        const allLocations = [defaultLocations, ...data.locations];
                        dispatch(Save_Locations(allLocations));
                    }
                } else {
                    toast.error(data?.msg || 'An error occurred');
                }
            },

            onError: (error) => {
                toast.error(error?.response?.data?.msg || 'An error occurred');
            },
        }
    );
    const handleAddClose = () => {
        setShowAddLocation(false);
    };

    return (
        <Container style={{ height: `${height}px`, overflow: 'auto', WebkitOverflowScrolling: 'touch' }}>
            <ModalHeader>
                <h1 className="text-white text-lg font-medium">Add Property</h1>
                <button onClick={handleClose}>
                    <MdClose color="white" size={24} />
                </button>
            </ModalHeader>

            <div className="px-6 h-full flex flex-col justify-between">
                {step === 1 && (
                    <BasicDetails
                        onClose={handleClose}
                        addBasicDetailLoading={addBasicDeailLoading}
                        addBasicDetailMutate={addBasicDetailMutate}
                        user={user}
                        setShowAddLocation={setShowAddLocation}
                    />
                )}
                {step === 2 && (
                    <TermsAgreement
                        onClose={handleClose}
                        propId={propId || selectedData.id}
                        addTermLoading={addTermLoading}
                        addTermMutate={addTermMutate}
                    />
                )}
                {step === 3 && (
                    <InitialSettlement
                        onClose={handleClose}
                        propId={propId || selectedData.id}
                        addRentLoading={addRentLoading}
                        addRentMutate={addRentMutate}
                    />
                )}
            </div>
            <SideModal
                isOpen={showAddLocation}
                onClose={() => setShowAddLocation(false)}
                level="high"
                width="11/12"
            >
                <AddLocation
                    setShowAddLocation={setShowAddLocation}
                    showAddLocation={showAddLocation}
                    addLocationLoading={addLocationLoading}
                    addLocationMutate={addLocationMutate}
                    handleClose={handleAddClose}
                />
            </SideModal>
        </Container>
    );
};
const Container = tw.div`bg-white w-full h-full flex flex-col relative`;
const Header = tw.div`flex items-center justify-between bg-[#0078BD] py-4 px-4`;
export default AddPropertyPage;